import { Component } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { select, Store } from '@ngrx/store';
import { AuthActions, AuthSelectors, AuthState } from '@nrwl/rx-state-auth';
import { Observable, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { RxSpinnerModule } from '@nrwl/rx-spinner';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-form-button',
  styleUrls: ['form-button.component.scss'],
  templateUrl: './form-button.component.html',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RxSpinnerModule, MatButtonModule],
})
export class FormButtonComponent implements Field {
  config: FieldConfig | any;
  group: FormGroup | any;

  public isBusy$: Observable<any>;

  constructor(private store: Store<AuthState.AuthState>) {
    this.isBusy$ = this.store.pipe(select(AuthSelectors.isBusy));
  }

  public getCssClass(): string[] {
    return ('outlined,' + this.config.cssClass).split(',');
  }
}
